import React from 'react';
import { motion } from 'framer-motion';

const ModelLoader = () => {
    return (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-b from-gray-100 to-gray-200 z-50">
            <div className="flex flex-col items-center space-y-6">
                {/* Spinning shirt icon */}
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "linear"
                    }}
                    className="w-16 h-16"
                >
                    <svg viewBox="0 0 24 24" fill="none" className="w-full h-full text-charcoal">
                        <path
                            d="M16 21V10.5C16 10.5 14.5 9 12 9C9.5 9 8 10.5 8 10.5V21M4 10L8 7L9 4L12 5.5L15 4L16 7L20 10L18 12L18 21H6L6 12L4 10Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill="none"
                        />
                    </svg>
                </motion.div>

                {/* Pulsing text */}
                <motion.p
                    animate={{ opacity: [0.5, 1, 0.5] }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="text-charcoal text-lg font-light tracking-wider uppercase"
                >
                    Loading 3D Model...
                </motion.p>

                {/* Loading dots */}
                <div className="flex space-x-2">
                    {[0, 1, 2].map((i) => (
                        <motion.div
                            key={i}
                            animate={{
                                y: [0, -10, 0],
                                scale: [1, 1.2, 1]
                            }}
                            transition={{
                                duration: 0.6,
                                repeat: Infinity,
                                delay: i * 0.2,
                                ease: "easeInOut"
                            }}
                            className="w-2 h-2 bg-charcoal rounded-full"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ModelLoader;
